import { PureComponent, PropsWithChildren } from "react";

export default class ExtrasFilterAdvancedFilterOptions extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-extras-filter__adv-filter-options">
        {this.props.children}
      </div>
    );
  }
}
